<template>
  <div class="helpPayForFaile">
    <!-- 二维码失效 -->
    <div class="success-img">
        <img src="../../assets/images/erweimashixiao.png" alt="">
    </div>
    <div class="erweima-text">二维码已失效</div>
    <div class="erweima-tips">请你朋友重新刷新二维码，再进行扫码支付</div>
    <div class="already" @click="toStudy">完成</div>
  </div>
</template>
<script>
export default {
  name: 'helpPayForFaile',
  data(){
      return{
      }
  },
  methods:{
      toStudy(){
          console.log('跳转到店铺页面')
        try {
            // wx.miniProgram.switchTab({url:"/pages/switchPage"});
            wx.miniProgram.redirectTo({url:"../../switchPage?into=0&flag=normal"});
        } catch (error) {
            throw error;
        }
      }
  },
  created(){
      document.title = "支付详情";
  }
}
</script>
<style lang="scss">
    html,body{
        margin:0;
        padding:0;
        width: 100%;
        height: 100%;
        background: #F8F8F8;
    }
    .helpPayForFaile{
        width: 100%;
        height: 100%;
        
        // 支付成功 
        .success-img{
            width: 163px;
            height: 150px;
            padding-top: 84px;
            margin:0 auto;
            img{
                width: 163px;
                height: 150px;
            }
        }
        .erweima-text{
            width: 84px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF6060;
            line-height: 20px;
            margin:0 auto;
            padding-top: 14px;
            padding-bottom: 12px;
        }
        .erweima-tips{
            width: 266px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin:0 auto;
            padding-bottom: 89px;
        }
        // 完成
        .already{
            width: 299px;
            height: 49px;
            background: linear-gradient(315deg, #FF6060 0%, #FB6460 100%);
            border-radius: 25px;
            margin:0 auto;
            line-height: 49px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
        }
    }
</style>

